import React, { Component } from 'react';
import {actions, connect} from 'mirrorx';

import DropboxIO from '../singletons/io';
import Pages from '../enums/pages';

import SaveCurrentFileModal from './save-current-file-modal';

import './sidebar-files.css';

class SidebarFiles extends Component {
	constructor() {
		super();
		this.io = null;

		this.onClickNewFile = this.onClickNewFile.bind(this);
		this.saveAndNewFileEvent = this.saveAndNewFileEvent.bind(this);
		this.onClickSaveFile = this.onClickSaveFile.bind(this);
		this.onClickSaveAs = this.onClickSaveAs.bind(this);
		this.onClickOpenFile = this.onClickOpenFile.bind(this);
	}

	componentDidMount() {
		this.io = new DropboxIO(this.props);
	}

	componentWillReceiveProps(nextProps) {
		if (this.io) {
			this.io.setProps(nextProps);
		}
	}

	onClickNewFile() {
		if (!this.props.editor.isDirty) {
			this.io.newFile();
		}
		else {
			this.refs.saveModal.activateModal();
		}
	}

	saveAndNewFileEvent(e) {
		this.io.saveFile(e).then(alreadySaved => {
			if (alreadySaved) {
				this.io.newFile();
			}
		})
	}

	onClickSaveFile() {
		this.io.saveFile().then(alreadySaved => {
	    	if (alreadySaved) {
	    		actions.autosave.addRecentPath({
	    			name: this.props.editor.file.name,
	    			path: this.props.editor.file.path,
	    			service: this.props.editor.file.service
	    		});
	    	}
	    });
	}

	onClickSaveAs() {
    actions.layout.setPage(Pages.SAVE_FILE);
	}

	onClickOpenFile() {
		this.io.openFile();
	}
	render() {
		return <div class='sidebar-files'>
		<h2>File Operations</h2>
			<button className='btn-link' onClick={this.onClickNewFile}>New File</button>
      <button className='btn-link' onClick={this.onClickOpenFile}>Open File</button>
      <button className='btn-link' disabled={!this.props.editor.isDirty} onClick={this.onClickSaveFile}>Save File</button>
      <button className='btn-link' onClick={this.onClickSaveAs}>Save File As</button>

      <SaveCurrentFileModal ref='saveModal' 
				name={this.props.editor.file.name} 
				path={this.props.editor.file.path} 
				service={this.props.editor.file.service}
				onClick={this.saveAndNewFileEvent}
				onCancel={actions.editor.reset}/>
		</div>
	}
}

export default connect(state => {
  return {editor: state.editor,
  layout: state.layout,
	services: state.services}
}, null, null, { withRef: true })(SidebarFiles)


// WEBPACK FOOTER //
// ./src/components/sidebar-files.js